const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Áreas de Serviço',
    description: 'Quando um proprietário procura instaladoras Enphase em uma área específica, usaremos o %{regionOrCountyLabel} informado por você aqui para verificar se você está disponível para serviço nessa área ou não.',
    addNewArea: 'Adicionar nova área',
    new: 'Novo',
    areaName: 'Nome da área',
    servicesCovered: {
      countiesCovered: 'Condados abrangidos',
      regionsCovered: 'Regiões abrangidas',
      provincesCovered: 'Províncias abrangidas',
      regionsWithCount: '%{region}(Primeiros %{typeCharacters} dígitos dos códigos postais) Abrangidos',
      districtsCovered: 'Distritos abrangidos',
      citiesCovered: 'Municípios abrangidos',
      citiesCoveredbr: 'Cidades abrangidos',      
      departments: 'departamentos',
      regions: 'regiões',
      counties: 'condados',
      districts: 'distritos',
      cities: 'municípios',
      provinces: 'Províncias',
      city: 'cidades'
    },
    selectAllCounty: 'Selecionar tudo %{regionOrCountyLabel} de um estado específico',
    selectAllCountyWithRegion: 'Selecionar tudo %{regionOrCountyLabel} De uma região específica',
    selectAllDepartment: 'Selecione todos os departamentos',
    addCountiesRegionsButton: 'Adicionar %{regionOrCountyLabel}',
    countyButtonDescription: 'Com base na sua seleção de estado, todos os relacionados %{regionOrCountyLabel} serão adicionados',
    countyButtonDescriptionWithRegion: 'Com base na sua seleção de região, todos os relacionados %{regionOrCountyLabel} serão adicionados',
    area1: 'AREA 1',
    selectState: 'Selecione o estado',
    selectRegion: 'Selecione a região',
    requestNotProcessed: 'A solicitação não pôde ser processada',
    footerTitle: 'O preço indicativo deve incluir os custos de instalação, prateleiras, módulo fotovoltaico, inversor, etc. Custos como cobertura, atualização do painel principal podem ser adicionais',
    footerBody: 'A Enphase fornecerá esse preço indicativo ao proprietário. A Enphase fornecerá uma isenção de responsabilidade ao proprietário informando que este preço é preliminar e está sujeito a alterações.',
    noBlankRegions: '%{regionOrCountyLabel} abrangido não pode ficar em branco',
    deleteConfirmation: 'Tem certeza de que deseja excluir esta área de serviço?',
    ok: 'Ok',
    infoText: '%{bTagOpen}A região%{bTagClose} é definida como os primeiros %{count} dígitos de um código postal em um %{stateOrProvince}',
    infoTextFr: 'O departamento é definido como os 2 primeiros dígitos do código postal',
    state: 'Estado',
    province: 'província',
    noOptions: 'Sem opções'
  }
};

export default serviceAreas;
